import React from "react";

interface IPersonAltIconProps {
    size?: number;
    color?: string;
    altColor?: string;
}

export const PersonAltIcon: React.FC<IPersonAltIconProps> = ({
                                                                 size = 24,
                                                                 color = "#575757",
                                                                 altColor = "#FFFFFF"
                                                             }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M50 50C54.3265 50 58.5558 48.7171 62.1531 46.3134C65.7504 43.9098 68.5542 40.4933 70.2099 36.4962C71.8655 32.4991 72.2987 28.1007 71.4547 23.8574C70.6106 19.6141 68.5272 15.7163 65.468 12.657C62.4087 9.59778 58.5109 7.51438 54.2676 6.67033C50.0243 5.82628 45.6259 6.25948 41.6288 7.91515C37.6317 9.57081 34.2153 12.3746 31.8116 15.9719C29.4079 19.5692 28.125 23.7985 28.125 28.125C28.125 33.9266 30.4297 39.4906 34.532 43.593C38.6344 47.6953 44.1984 50 50 50ZM50 56.25C36.4414 56.25 9.375 64.625 9.375 81.25V93.75H90.625V81.25C90.625 64.625 63.5586 56.25 50 56.25Z"
                fill={color}/>
            <path d="M50.25 77.5L37.0431 54.625L63.4569 54.625L50.25 77.5Z" fill={altColor}/>
        </svg>
    );
};
